<template>
  <!-- Image Logo-->
  <el-image class="logo" :fit="fits" :alt="alt" :src="url">
    <div slot="error" class="image-error">
      <i class="el-icon-picture-outline"></i>
    </div>
  </el-image>
</template>

<script>
export default {
  name: "Logo",
  data() {
    return {
      fits: "cover",
      alt: "Pozos Manantial",
      url: require("@/assets/images/logo-transparent.png"),
    };
  },
};
</script>
